import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import AccountCircle from '@mui/icons-material/AccountCircle';
import NotificationsIcon from '@mui/icons-material/NotificationsNone';
import CssBaseline from '@mui/material/CssBaseline';
import useLogOut from 'Hooks/useLogOut';
import MenuContainer from './Components/MenuContainer';
import useComponent from './Hooks/useComponent';
import useTranslation from '../../Hooks/useTranslation';
import { colors } from '../../Constants/Colors';

export default function PrimarySearchAppBar() {
  const [anchorEl, setAnchorEl] = useState(null);
  const openOptions = Boolean(anchorEl);
  const { t2 } = useTranslation('Navbar');
  const options = [t2('LogoutUserOptions')];
  const { Component, setOpenModal, selectedIndex, setSelectedIndex } = useComponent();
  const { logOutApi } = useLogOut();
  const optionEvents = [logOutApi];

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const event = () => {
    setOpenModal(true);
    setSelectedIndex(0);
  };

  return (
    <AppBar position="static" style={{ background: colors.WHITE, marginBottom: '.5rem' }}>
      <CssBaseline />
      <Toolbar style={{ flexDirection: 'row' }}>
        <Box sx={{ flexGrow: 1 }} />
        <IconButton
          size="large"
          color="inherit"
          id="long-button"
          aria-expanded={openOptions ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <AccountCircle style={{ color: colors.GRAY_ACCOUNT_BUTTON }} />
        </IconButton>

        <MenuContainer
          options={options}
          event={event}
          anchorEl={anchorEl}
          openOptions={openOptions}
          handleClose={handleClose}
        />
        <Component index={selectedIndex} optionEvents={optionEvents} />
      </Toolbar>
    </AppBar>
  );
}
